import { EventEmitter, Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class AliasService {

    aliasChanged: EventEmitter<void> = new EventEmitter();

    notifyAliasChange(): void {
        this.aliasChanged.emit();
    }
}
